import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/CatatanKebidanan";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "catatan-kebidanan"
})
class CatatanKebidananStoreModule extends VuexModule {
  loading = false;
  dataList: any[] = [];

  @Mutation
  SET_DATALIST(val: any[]) {
    this.dataList = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.dataList = [];
  }

  @Action({ rawError: true })
  async getByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_DATALIST(response?.data ?? []);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(CatatanKebidananStoreModule);
